import React, { useState } from "react";
import "./style.scss";
import { HeaderSearchIcon } from "assets/icons";
import Button from "components/BaseWidgets/button";
import SearchPage from "./components/SearchPage";
import useMediaQuery from "hooks/useMediaQuery";

const HeaderSearch = () => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 991px)");

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant="custom"
        className="header-search-btn"
      >
        {
          !isMobile &&
          "Search"
        }
        <div className="search-icon">
          <HeaderSearchIcon />
        </div>
      </Button>
      {open && <SearchPage setOpen={setOpen} open={open} />}
    </>
  );
};

export default HeaderSearch;
